import React, { useEffect } from 'react';
import { HiCheck, HiX } from 'react-icons/hi';
import styles from './Toast.module.css';

export type ToastVariant = 'success' | 'error';

export interface ToastProps {
  id: string;
  message: string;
  variant?: ToastVariant;
  duration?: number;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({
  id,
  message,
  variant = 'success',
  duration = 3000,
  onClose
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(id);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const handleClose = () => {
    onClose(id);
  };

  const Icon = variant === 'success' ? HiCheck : HiX;

  return (
    <div className={`${styles.toast} ${styles[variant]}`} role="alert" aria-live="polite">
      <div className={styles.iconContainer}>
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
        {/* @ts-ignore - react-icons compatibility with React 19 */}
        <Icon className={styles.icon} />
      </div>
      <div className={styles.message}>{message}</div>
      <button
        className={styles.closeButton}
        onClick={handleClose}
        aria-label="Close notification"
        type="button"
      >
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
        {/* @ts-ignore - react-icons compatibility with React 19 */}
        <HiX className={styles.closeIcon} />
      </button>
    </div>
  );
};

export default Toast;

